import { escapeRegExp } from './escapeRegExp';

/**
 * Function to case insensitive compare, can be used as factory
 * Uses regex for readability & performance over `.includes`
 */
export const compareCaseInsensitive = (
  query: string,
): ((value: string) => boolean) => {
  const regExp = new RegExp(escapeRegExp(query.trim()), 'i');

  return (value: string) => regExp.test(value);
};
